/* Progressive enhancement only. No pricing, cart, storage, tracking or automatic video requests. */
(() => {
  'use strict';
  if (window.KlikProductContinuation) { window.KlikProductContinuation.init(document); return; }
  const bound = new WeakSet();
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(scope) {
    scope.querySelectorAll('[data-kpe]').forEach(root => {
      if (bound.has(root)) return;
      bound.add(root);
      const roomGuide=document.querySelector('.klik-search-guide'),fit=root.querySelector('.kpe-fit-disclosure');
      if(roomGuide&&fit){roomGuide.classList.add('kpe-integrated-guide');fit.append(roomGuide);}
      // Anchor links reveal their target disclosure before scrolling to it.
      root.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', () => {
        const target = document.getElementById(link.getAttribute('href').slice(1));
        if (target?.matches('details')) target.open = true;
        const detail = target?.closest('details');
        if (detail) detail.open = true;
      }));
      if ('IntersectionObserver' in window && !reduced()) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0, rootMargin: '0px 0px 64px 0px' });
        root.classList.add('kpe-ready');
        root.querySelectorAll('[data-kpe-reveal]').forEach(node => observer.observe(node));
      }
      root.querySelectorAll('[data-kpe-return]').forEach(link => link.addEventListener('click', event => {
        const main = document.getElementById(root.dataset.mainId);
        if (!main) return;
        const visible = node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';
        const target = [...main.querySelectorAll('[data-kp6-primary],[data-ready-open],[data-furniture-open],[data-sofa-fixed-open],[data-klik-start-builder],form.product-single__form [data-add-to-cart]')].find(visible);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
        target.focus({ preventScroll: true });
      }));
      const dialog = root.querySelector('[data-kpe-dialog]');
      const frame = root.querySelector('[data-kpe-frame]');
      let opener;
      if (!dialog || !frame || !dialog.showModal) return;
      root.querySelectorAll('[data-kpe-video]').forEach(link => link.addEventListener('click', event => {
        const id = link.dataset.kpeVideo;
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
        event.preventDefault();
        // The legacy theme also binds YouTube links. This dialog owns this action.
        event.stopImmediatePropagation();
        opener = link;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        iframe.title = dialog.getAttribute('aria-label');
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.replaceChildren(iframe);
        dialog.showModal();
      }, true));
      root.querySelector('[data-kpe-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        frame.replaceChildren();
        requestAnimationFrame(() => {
          if (opener?.isConnected) opener.focus({ preventScroll: true });
        });
      });
    });
  }
  window.KlikProductContinuation = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
